// Slug único para o site inteiro. Importado tanto pelo app (browser) quanto
// pelos plugins do Vite (node) — se os dois usassem algoritmos diferentes, os
// links do índice "Nesta página" apontariam para âncoras que não existem.
const COMBINING_MARKS = /[\u0300-\u036f]/g;

export function slugify(input: unknown): string {
  return String(input)
    .toLowerCase()
    .normalize("NFD")
    .replace(COMBINING_MARKS, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

// Âncora de um endpoint da referência. Método entra no slug porque o mesmo path
// pode existir com verbos diferentes (GET e POST /avail/hotel, por exemplo).
export function operationSlug(method: string, path: string): string {
  return slugify(`${method}-${path}`);
}
